var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrackIcon = function SvgTrackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.6667C12 25.6122 9.61223 28 6.66671 28C3.72119 28 1.33337 25.6122 1.33337 22.6667C1.33337 19.7211 3.72119 17.3333 6.66671 17.3333C9.61223 17.3333 12 19.7211 12 22.6667ZM12 22.6667V4.92602C12 4.40348 12.4023 3.96904 12.9233 3.92897L28.2567 2.74948C28.8375 2.7048 29.3334 3.16402 29.3334 3.74653V21.3333M29.3334 21.3333C29.3334 24.2788 26.9456 26.6667 24 26.6667C21.0545 26.6667 18.6667 24.2788 18.6667 21.3333C18.6667 18.3878 21.0545 16 24 16C26.9456 16 29.3334 18.3878 29.3334 21.3333Z",
    stroke: "var(--on-surface)",
    strokeWidth: 2
  })));
};
export default SvgTrackIcon;